
export default function DestinationSection() {
  const ixtapaAttractions = [
    {
      name: 'Playa El Palmar',
      description: 'Playa principal de Ixtapa con hoteles de lujo, restaurantes y actividades acuáticas.',
      image: 'https://public.readdy.ai/ai/img_res/39077011f7c9dbffd7b08f45b9c4f7a6.jpg'
    },
    {
      name: 'Isla Ixtapa',
      description: 'Isla paradisíaca a 10 minutos en lancha con playas vírgenes y vida marina.',
      image: 'https://readdy.ai/api/search-image?query=Isla%20Ixtapa%20paradise%20island%20Mexico%20with%20pristine%20beaches%2C%20crystal%20clear%20turquoise%20water%2C%20tropical%20vegetation%2C%20boats%20arriving%20at%20the%20island%2C%20snorkeling%20activities%2C%20peaceful%20island%20atmosphere&width=500&height=300&seq=isla-ixtapa&orientation=landscape'
    },
    {
      name: 'Campo de Golf',
      description: 'Campo de golf de clase mundial diseñado por Robert Trent Jones Jr.',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20golf%20course%20in%20Ixtapa%20Mexico%20designed%20by%20Robert%20Trent%20Jones%20Jr%2C%20beautiful%20green%20fairways%2C%20ocean%20views%2C%20palm%20trees%2C%20professional%20golf%20facilities%2C%20tropical%20landscape%20setting&width=500&height=300&seq=golf-ixtapa&orientation=landscape'
    },
    {
      name: 'Marina Ixtapa',
      description: 'Marina moderna con yates, restaurantes gourmet y vida nocturna exclusiva.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Marina%20Ixtapa%20Mexico%20with%20luxury%20yachts%2C%20upscale%20restaurants%2C%20nightlife%20venues%2C%20waterfront%20dining%2C%20sophisticated%20marina%20atmosphere%2C%20evening%20lights%20reflecting%20on%20water&width=500&height=300&seq=marina-ixtapa&orientation=landscape'
    }
  ];

  const zihuatanejoAttractions = [
    {
      name: 'Playa La Ropa',
      description: 'Una de las playas más hermosas de México con aguas cristalinas y arena dorada.',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Playa%20La%20Ropa%20beach%20in%20Zihuatanejo%20Mexico%20with%20crystal%20clear%20turquoise%20water%2C%20golden%20sand%2C%20palm%20trees%2C%20peaceful%20tropical%20paradise%20setting%2C%20tourists%20enjoying%20the%20beach%2C%20stunning%20coastal%20landscape%20photography%2C%20perfect%20weather%20and%20blue%20sky&width=500&height=300&seq=playa-ropa&orientation=landscape'
    },
    {
      name: 'Centro Histórico',
      description: 'Calles empedradas, arquitectura colonial y el encanto auténtico de un pueblo mágico.',
      image: 'https://readdy.ai/api/search-image?query=Historic%20downtown%20Zihuatanejo%20Mexico%20with%20cobblestone%20streets%2C%20colorful%20colonial%20architecture%2C%20traditional%20Mexican%20buildings%2C%20local%20shops%20and%20restaurants%2C%20authentic%20pueblo%20magico%20atmosphere%2C%20charming%20town%20center%20photography&width=500&height=300&seq=centro-historico&orientation=landscape'
    },
    {
      name: 'Playa Principal',
      description: 'El corazón de Zihuatanejo con restaurantes frente al mar y ambiente vibrante.',
      image: 'https://readdy.ai/api/search-image?query=Playa%20Principal%20main%20beach%20in%20Zihuatanejo%20with%20waterfront%20restaurants%2C%20fishing%20boats%2C%20vibrant%20local%20atmosphere%2C%20people%20dining%20and%20enjoying%20beachfront%20activities%2C%20traditional%20Mexican%20coastal%20town%20scene%2C%20lively%20beach%20setting&width=500&height=300&seq=playa-principal&orientation=landscape'
    },
    {
      name: 'Playa Las Gatas',
      description: 'Playa protegida perfecta para snorkel y actividades acuáticas familiares.',
      image: 'https://readdy.ai/api/search-image?query=Playa%20Las%20Gatas%20protected%20beach%20in%20Zihuatanejo%20perfect%20for%20snorkeling%2C%20calm%20clear%20waters%2C%20families%20enjoying%20water%20activities%2C%20tropical%20fish%20visible%20in%20shallow%20water%2C%20peaceful%20bay%20setting%20with%20rocky%20formations&width=500&height=300&seq=playa-gatas&orientation=landscape'
    }
  ];

  const hotels = [
    {
      category: 'Hoteles de Lujo en Ixtapa',
      items: [
        'Grand Velas All Suites & Spa Resort',
        'Azul Ixtapa Grand All Suites Spa & Convention Center',
        'Las Brisas Ixtapa',
        'Barceló Ixtapa',
        'Sunscape Dorado Pacifico'
      ]
    },
    {
      category: 'Hoteles Boutique en Zihuatanejo',
      items: [
        'La Casa Que Canta',
        'Villa del Sol',
        'Hotel Villa Mexicana',
        'Tentaciones Hotel',
        'Aura del Mar'
      ]
    }
  ];

  return (
    <section id="destino" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Descubre Ixtapa-Zihuatanejo
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Dos destinos únicos en uno: la modernidad y lujo de Ixtapa junto con la tradición 
            y encanto de Zihuatanejo. Te llevamos a ambos paraísos con comodidad y seguridad.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              ¿Por qué elegir Ixtapa-Zihuatanejo?
            </h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-building-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Dos Destinos en Uno</h4>
                  <p className="text-gray-600">Ixtapa ofrece resorts de lujo y modernidad, mientras Zihuatanejo conserva su encanto tradicional de pueblo mágico.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-sun-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Clima Perfecto</h4>
                  <p className="text-gray-600">Temperatura promedio de 26°C todo el año, ideal para disfrutar de las playas y actividades al aire libre.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-leaf-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Naturaleza Exuberante</h4>
                  <p className="text-gray-600">Playas vírgenes, selva tropical y una biodiversidad increíble que te conecta con la naturaleza.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-restaurant-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Gastronomía Excepcional</h4>
                  <p className="text-gray-600">Desde restaurantes gourmet en Ixtapa hasta mariscos frescos en Zihuatanejo, una experiencia culinaria única.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Stunning%20panoramic%20aerial%20view%20of%20Ixtapa%20and%20Zihuatanejo%20bay%20Mexico%20showing%20both%20modern%20resort%20area%20and%20traditional%20fishing%20village%2C%20beautiful%20coastline%2C%20luxury%20hotels%2C%20crystal%20clear%20blue%20water%2C%20tropical%20mountains%20in%20background%2C%20perfect%20contrast%20between%20modern%20and%20traditional&width=600&height=500&seq=ixtapa-zihua-panorama&orientation=landscape"
              alt="Vista panorámica de Ixtapa-Zihuatanejo"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <h4 className="text-2xl font-bold mb-2">Bahía de Ixtapa-Zihuatanejo</h4>
              <p className="text-lg">Dos paraísos te esperan</p>
            </div>
          </div>
        </div>

        {/* Sección de Hoteles */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Principales Hoteles
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {hotels.map((category, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg">
                <h4 className="text-xl font-bold text-gray-900 mb-6 text-center">{category.category}</h4>
                <ul className="space-y-3">
                  {category.items.map((hotel, hotelIndex) => (
                    <li key={hotelIndex} className="flex items-center text-gray-700">
                      <i className="ri-hotel-line text-blue-600 mr-3"></i>
                      {hotel}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Atractivos de Ixtapa */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Atractivos de Ixtapa
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {ixtapaAttractions.map((attraction, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                <img 
                  src={attraction.image}
                  alt={attraction.name}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-3">{attraction.name}</h4>
                  <p className="text-gray-600 text-sm">{attraction.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Atractivos de Zihuatanejo */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Atractivos de Zihuatanejo
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {zihuatanejoAttractions.map((attraction, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                <img 
                  src={attraction.image}
                  alt={attraction.name}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-3">{attraction.name}</h4>
                  <p className="text-gray-600 text-sm">{attraction.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Actividades */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Actividades Imperdibles
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-4">
                <i className="ri-ship-line text-blue-600 text-xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-3">Paseos en Lancha</h4>
              <p className="text-gray-600 text-sm">Visita Isla Ixtapa, avistamiento de delfines y pesca deportiva en aguas cristalinas.</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mb-4">
                <i className="ri-diving-line text-green-600 text-xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-3">Snorkel y Buceo</h4>
              <p className="text-gray-600 text-sm">Explora arrecifes de coral en Playa Las Gatas y descubre la vida marina tropical.</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg mb-4">
                <i className="ri-shopping-bag-line text-orange-600 text-xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-3">Compras y Artesanías</h4>
              <p className="text-gray-600 text-sm">Mercado de artesanías en Zihuatanejo y centros comerciales modernos en Ixtapa.</p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-teal-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">¿Listo para tu Aventura en Ixtapa-Zihuatanejo?</h3>
          <p className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
            Deja que nosotros nos encarguemos del transporte mientras tú te enfocas en disfrutar 
            de estos dos paraísos tropicales. Tu aventura comienza desde el momento en que aterrizas.
          </p>
          <button 
            onClick={() => document.getElementById('reserva')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-600 hover:bg-gray-100 rounded-lg font-bold text-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line mr-2"></i>
            Reservar Mi Transporte
          </button>
        </div>
      </div>
    </section>
  );
}
